// extracted by mini-css-extract-plugin
export default {"contentContainer":"src-components-DragRowDisplay-TextOnly-css__contentContainer--dJVd5","sku":"src-components-DragRowDisplay-TextOnly-css__sku--oSpQN"};